<template>
    <div class="root" v-loading="loading">
        <div style="height: 1px;"></div>
        <div class=" theme-showcase">

            <div class="contentDiv" ref="scrollContainer" style="background-color: #f1f1f1;">
                <div v-for="(item, index) in list" :key="item.id" class="itemdiv">
                    <div style="display: flex; font-size: 16px; color: #666;"><img
                            src="https://jinyuan.daxuxian.com/images/icon/date.png"
                            style="width: 24px; height: 24px; margin-right: 5px;" /> {{ item.CreateTime }}</div>
                    <div style="font-size:16px; margin: 5px 0; color: #666;">来源：微信</div>
                    <div style="font-size: 16px; color: #666;">类型：{{ item.Category }}</div>
                    <div style="margin: 5px 0; font-size: 16px; color: #666;">所选门店：{{ item.ShopName }}</div>
                    <div style="font-size: 18px; white-space: pre-wrap; overflow-wrap: break-word;">{{ item.ContentTxt }}</div>
                    <div style="padding: 2px 0px; margin: 0 -5px;">
                        <div v-for="item2 in item.ImgUrls" :key="item2" :class="{ 'inlineblockdiv': item.inlineblock }"
                            @click="triggleImg(index)">
                            <div style="margin: 5px; border: 1px #f1f1f1 solid;">
                                <img :src="item2" style="width: 100%;" />
                            </div>
                        </div>
                    </div>

                    <div style="margin: 8px 0; height: 1px; width: 100%; border-top: 1px #ddd dashed;"></div>

                    <div style="display: flex; font-size: 16px; color: #1195db;"><img
                            src="https://jinyuan.daxuxian.com/images/icon/chulijieguo.png"
                            style="width: 24px; height: 24px; margin-right: 5px;" />处理结果</div>
                    <div style="font-size:16px; margin: 5px 0; color: #666;">回复时间：{{ item.HandleTime }}</div>
                    <div style="font-size:16px; margin: 5px 0; color: #666;">处理人：{{ item.HandleUserName }}</div>
                    <div style="font-size: 18px; white-space: pre-wrap; overflow-wrap: break-word;">{{ item.HandleTxt }}</div>


                    <img src="https://jinyuan.daxuxian.com/images/icon/yichuli.png"
                        style="width: 50px; position:absolute; right: 20px; top:15px;" />
                </div>
            </div>

            <div v-if="loading" class="loading" style="background-color: #f1f1f1; text-align: center;">加载中...</div>
            <div v-if="noMore" class="no-more" style="background-color: #f1f1f1; text-align: center; max-width: 520px; margin: auto; ">没有更多数据了</div>

            <div style="background-color: #f1f1f1; height: 80px; max-width: 520px; margin: auto; "></div>

            <div style="position: fixed; bottom: 0; left: 0; width: 100vw; border-top: 1px #c8c8c8 solid;">
                <div
                    style="max-width: 520px; margin: auto; background-color: #f7f6fb; display: flex; padding: 6px 0; color: gray; font-size: 14px; line-height: 18px;">
                    <div style="flex: 1;text-align: center;" @click="tosug">
                        <div><img style="width:26px;" src="https://jinyuan.daxuxian.com/images/icon/biji1.png" /></div>
                        <div style="text-align: center;">提建议</div>
                    </div>
                    <div style="flex: 1;text-align: center;" @click="tosuglist">
                        <div><img style="width:26px;" src="https://jinyuan.daxuxian.com/images/icon/gongshi2.png" />
                        </div>
                        <div style="text-align: center; color: #1aac19;">意见建议公示台</div>
                    </div>
                    <div style="flex: 1; text-align: center;" @click="tomysug">
                        <div><img style="width:26px;" src="https://jinyuan.daxuxian.com/images/icon/wode1.png" /></div>
                        <div style="text-align: center;">我的建议</div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

import axios from 'axios'

export default {
    name: 'suglist',
    data: function () {
        return {
            form: {},
            amount: '',
            count: "",
            amountErr: '',
            countErr: '',
            preRegNo: '',
            AutoCheckin: false,
            AutoPrint: false,
            id: 0,
            eventId: '',
            eventList: [],
            loading: false,
            noMore: false,
            dialogFormVisible: false,
            angle: 0,
            x: 0,
            y: 0,
            w: 100,
            h: 100,
            imgUrl: '',
            showDetails: false,
            currentPage: 1,
            list: [],
            total: 0,
            nickname: '',
            dialogTableVisible: false,
            hideUploadBtn: false,
            fileList: [],
            shopname: '',
            shopid: '',
            phone: '',
            contenttxt: '',
            imgids: [],
            shopnameErr: '',
            phoneErr: "",
            contentErr: '',
            shoplist: []
        }
    },
    components: {

    },
    methods: {
        triggleImg(index) {
            console.log(index);
            this.list[index].inlineblock = !this.list[index].inlineblock;
        },
        tosug() {
            this.$router.push('/');
        },
        tosuglist() {
            this.$router.push('/suglist');
        },
        tomysug() {
            this.$router.push('/mysug');
        },

        goBack() {
            this.$router.back();
        },

        loadData(p) {
            this.loading = true;
            var page = this.currentPage;
            if (p == 1) {
                this.currentPage = 1;
                page = 1;
            }
            axios.post('/api/Suggestion/SuggestionList',
                {
                    skip: (page - 1) * 10,
                    limit: 10,
                    openid: 'oqyAl3WRVTrmee2Qp8Vg9ua-tH9A',
                    token: 'bc5750078e320f67265bc65f19ad4a79'
                }
            )
                .then(this.loadDataSucc)
        },
        loadDataSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                // this.list = res.list;
                this.list = [...this.list, ...res.list];
                this.total = res.total;
                if (res.list != null && res.list.length > 0) {
                    var item = res.list[0];
                } else {

                }
                if (res.list.length < 10) {
                    this.noMore = true;
                }
            } else {
                if (res && res.Code == 301) {
                    
                }
            }
        },


        // 滚动监听核心方法
        handleScroll() {
            // 文档总高度
            const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            // 当前滚动距离 + 可视窗口高度
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const clientHeight = document.documentElement.clientHeight || window.innerHeight;

            // 距离底部 50px 时触发加载（可自行调整）
            if (scrollTop + clientHeight + 50 >= scrollHeight) {
                // 防止重复请求 + 没有更多数据时不触发
                if (!this.loading && !this.noMore) {
                    this.currentPage++;
                    this.loadMoreData();
                }
            }
        },
        loadMoreData() {
            this.loadData();
            // this.$message("到底了！");
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll, true);
        this.loadData(1);
    },
    beforeDestroy() {
        // 页面销毁时移除监听，防止内存泄漏
        window.removeEventListener('scroll', this.handleScroll, true);

    }
}
</script>
<style scoped>
.contentDiv>div {
    font-size: 18px;
    line-height: 24px;
}

.contentDiv {
    padding: 1px;
    max-width: 520px;
    margin: auto;
}

.inlineblockdiv {
    display: inline-block;
    width: 33.33%;
}

.itemdiv {
    position: relative;
    background: #fff;
    margin: 12px 10px;
    padding: 10px;
    border-end-end-radius: 10px;
    border-end-start-radius: 10px;
    border-top: 3px #1195db solid;
}

.mytd {
    border-bottom: 1px #ccc solid;
    border-right: 1px #ccc solid;
    padding: 10px;
    margin: 0;
    box-sizing: border-box;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}

.root>>>.topmenuitem:nth-child(10) {
    color: #fff;
    background-color: #080808;
}

.root>>>.el-dialog {
    width: 80% !important;
}



.rootdiv>>>.topmenuitem:nth-child(8) {
    color: #fff;
    background-color: #080808;
}

.avatar-uploader>>>.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader>>>.el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader>>>.el-upload--picture-card {
    width: 20vw !important;
    height: 20vw !important;
    line-height: 20vw;
}

.avatar-uploader>>>.el-upload-list__item {
    width: 20vw;
    height: 20vw;
}

.avatar-uploader>>>.el-upload {}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 20vw !important;
    height: 20vw !important;
    line-height: 20vw;
    text-align: center;
}

.avatar {
    width: 20vw;
    display: block;
}

.hide {
    .el-upload--picture-card {
        display: none !important;
    }
}

.root>>>.el-dialog__body {
    padding: 1px !important;
}

.root>>>.el-dialog__header {
    padding: 16px 10px 10px 10px;
    border-bottom: 1px #f1f1f1 solid;
}

.divshopitem {
    border-bottom: 1px #f1f1f1 solid;
    padding: 12px 15px;
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/suggestions/suglist.vue